"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const PreferencesDialog_vue_1 = require("@/client/components/PreferencesDialog.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PreferencesIcon',
    components: {
        'preferences-dialog': PreferencesDialog_vue_1.default,
    },
    data() {
        return {
            preferencesPanelOpen: false,
        };
    },
    computed: {
        preferencesManager() {
            return PreferencesManager_1.PreferencesManager.INSTANCE;
        },
    },
});
